import { render, staticRenderFns } from "./IristarNews.vue?vue&type=template&id=a1cc094e&"
import script from "./IristarNews.vue?vue&type=script&lang=js&"
export * from "./IristarNews.vue?vue&type=script&lang=js&"
import style0 from "./IristarNews.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports